<template>
    <div>
      <el-dialog title="设置接待时间" width="40%" style="font-weight:bold;font-size:30px;" :visible.sync="setTimeShow" :close-on-click-modal= "false"  @close="closeTimeShow" center>
        <p>注：此接待时间内，在线客服点击时将进行VIP身份检索，如果未接入，将跳转至企点QQ</p>
        <el-form  style="margin-left:-40px;margin-top:15px;">
          <el-form-item  label="" :label-width="formInputWidth" v-for="item in timeOptions" :key="item.index">
              <el-col :span="24">
                  <el-time-picker
                    is-range
                    v-model="item.value"
                    format='HH:mm'
                    value-format="HH:mm"
                    range-separator="至"
                    start-placeholder="开始时间"
                    end-placeholder="结束时间"
                    placeholder="选择时间范围"
                    >
                  </el-time-picker>
                   <el-button
                          class="filter-item"
                          style="margin-left: 10px;"
                          type="danger"
                          @click="deleteTime(item)"
                  >删除</el-button>
              </el-col>
            </el-form-item>
        </el-form>
        <el-button
                class="filter-item"
                style="margin-left: 50px;background-color:#ff9933;color:white;"
                @click="addTime"
        >添加</el-button>
         <div slot="footer" class="dialog-footer">
            <el-button @click="removeTime">取 消</el-button>
            <el-button type="primary" @click="sureTime">确认</el-button>
         </div>
      </el-dialog>
    </div>
</template>

<script>
export default {
  name: 'receptionTimePopup',
  props: {
    timeOptions: {
      type: Array
    },
    setTimeShow:{
      type: Boolean,
      default:false,
    }
  },
  data() {
    return {
        formInputWidth:"200px",
        timeShow:"",
        }
  },
  created(){
  },
  methods: {
    deleteTime(item){
      this.$emit("deleteTime", item);
    },
    addTime(){
      this.$emit("addTime");
    },
    removeTime(){
      this.$emit("removeTime");
    },
    sureTime(){
      this.$emit("sureTime");
    },
    closeTimeShow(){
      this.$emit("closeTimeShow");
    },
  },
}

</script>